import parse from 'html-react-parser';
import { files } from 'arquivos-estaticos';
import { IResources } from './interface-resources'
import { VariaveisAmbiente } from 'ambiente';
import { SaurusPedidosTema } from 'temas'


/* eslint-disable no-eval */
const resSaurusPedidos = () => {
  const fileReader = files();
  const getObject = () => {
    return {
      nome: 'HUB de Pedidos',
      theme: SaurusPedidosTema,
      tituloPagina: 'HUB de Pedidos Auth - Bem Vindo!',
      favIcon: fileReader.loadFavIcon('saurusPedidos', 'favicon.ico'),
      logo: fileReader.loadLogo('saurusPedidos', 'logo.png'),
      // Remover ao implementar o upload de gravatar - Vinicius Serafim 28-06-2021
      gravatarTemp: fileReader.loadGravatar('saurusPedidos', 'icon.png'),
      footer: parse(`HUB de Pedidos © - Copyright ${new Date().getFullYear()} - Todos os direitos reservados.` + (VariaveisAmbiente.isDev ? " - DEV" : ""))
    } as IResources;
  };

  return { getObject };
};

export const saurusPedidos = resSaurusPedidos();
/* eslint-enable no-eval */
